import {priceHTML, discountedPrice} from './bb-sale-prices.js';
export {discountedPrice};
export function validConfig(config) {
  return Boolean(config && config.enabled === true && /^[a-f0-9]{32}$/.test(config.key || '') && Number.isInteger(config.percent) && config.percent > 0 && config.percent <= 100 && Number.isFinite(config.start) && config.start > 0 && Number.isFinite(config.end) && config.end > config.start);
}
export function saleActive(config, now = Date.now()) { return validConfig(config) && now >= config.start && now < config.end; }
export function readSaleConfig(root = globalThis.document) {
  try { return JSON.parse(root?.querySelector('[data-bb-sale-config]')?.dataset.config || 'null'); } catch { return null; }
}
export function matchesSale(key, config = readSaleConfig(), now = Date.now()) { return saleActive(config, now) && key === config.key; }
export function decorateSale(card, key, config = readSaleConfig()) {
  const badge = card.querySelector('[data-bb-sale-badge]'); if (!badge) return;
  badge.dataset.bbSaleKey = /^[a-f0-9]{32}$/.test(key || '') ? key : '';
  badge.hidden = !matchesSale(badge.dataset.bbSaleKey, config);
  if (validConfig(config)) { badge.textContent = config.percent + '% OFF'; badge.setAttribute('aria-label', config.percent + '% off in cart'); }
}
export function saleBadgeHTML(key, config = readSaleConfig()) {
  if (!/^[a-f0-9]{32}$/.test(key || '') || !validConfig(config) || key !== config.key) return '';
  return '<span class="bb-sale-badge bb-sale-badge--inline" data-bb-sale-badge data-bb-sale-key="' + key + '" aria-label="' + config.percent + '% off in cart"' + (saleActive(config) ? '' : ' hidden') + '>' + config.percent + '% OFF</span>';
}
export function salePriceHTML(data, key, options = {}, config = readSaleConfig()) {
  const eligible = validConfig(config) && key === config.key;
  return priceHTML(data,{...options,key:eligible?key:'',percent:eligible?config.percent:0,active:matchesSale(key,config)});
}
export function refreshPrices(root, config, now) {
  const nodes = [...(root.matches?.('[data-bb-price]')?[root]:[]),...root.querySelectorAll('[data-bb-price]')];
  nodes.forEach(node=>{const promo=node.querySelector('[data-bb-price-promo]'),regular=node.querySelector('[data-bb-price-regular]');const active=Boolean(promo&&matchesSale(node.dataset.bbPriceKey,config,now));if(regular)regular.hidden=active;if(promo)promo.hidden=!active;});
}
export function refreshSale(root = globalThis.document, now = Date.now()) {
  if (!root) return; const config = readSaleConfig(root), active = saleActive(config, now);
  refreshPrices(root, config, now);
  root.querySelectorAll('[data-bb-sale-active]').forEach(node => { node.hidden = !active; });
  root.querySelectorAll('[data-bb-sale-inactive]').forEach(node => { node.hidden = active; });
  root.querySelectorAll('[data-bb-sale-key]').forEach(node => { node.hidden = !matchesSale(node.dataset.bbSaleKey, config, now); });
}
if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  let timer;
  function update() {
    clearTimeout(timer); refreshSale(); document.dispatchEvent(new Event('bb:sale-refreshed')); const config = readSaleConfig(), now = Date.now();
    if (!validConfig(config)) return;
    const next = [config.start, config.end].filter(time => time > now).sort((a,b) => a-b)[0];
    if (next) timer = setTimeout(update, Math.min(next - now + 20, 2147483647));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, {once:true}); else update();
  document.addEventListener('visibilitychange', update); window.addEventListener('pageshow', update);
  document.addEventListener('bb:cards-loaded', () => refreshSale());
  document.addEventListener('shopify:section:load', update);
  // Variant selections and app-rendered sections can replace their price nodes.
  new MutationObserver(records=>{
    const config=readSaleConfig(), now=Date.now();
    for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1&&
      (node.matches('[data-bb-price],[data-bb-sale-key]')||node.querySelector('[data-bb-price],[data-bb-sale-key]'))){
      refreshPrices(node,config,now);
      for(const badge of [ ...(node.matches('[data-bb-sale-key]')?[node]:[]), ...node.querySelectorAll('[data-bb-sale-key]')])badge.hidden=!matchesSale(badge.dataset.bbSaleKey,config,now);
    }
  }).observe(document.body,{childList:true,subtree:true});
}
